import React from "react";
import { debug } from "../../utils";
import { connect } from "react-redux";

function DomainSetField({ value, onChange, disabled }) {

    // const onChange = (value) => {
    //     modalDataService.changeDomainSet(value);
    //     //!value && modalDataService.unselectAllEvents();
    // }

    return (
        <div className="form-group edit-device-option-row">
                <label className={`edit-device-option-label ${disabled ? "is-disabled" : ""}`}>
                    <input type="checkbox" 
                        className="edit-device-option-input"
                        checked={!!value} 
                        disabled={disabled}
                        onChange={disabled ? null : () => onChange(!value)} />
                    <span className={`edit-device-option-box ${value ? "is-checked" : ""}`} aria-hidden="true">
                        <span className="edit-device-option-check">✓</span>
                    </span>
                    <span className="edit-device-option-text">Add/Edit Domain Configuration</span>
                </label>
        </div>
    )

}

function mapStateToProps(state) {
    debug("EnableSyslogProcessingField mapStateToProps", state);
    const addDeviceModal = state.addDeviceModal;
    return {
        domainSet: addDeviceModal.domainSet || ''
    }
}

export default connect(mapStateToProps)(DomainSetField);
